import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Play from "@/pages/Play";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import WorldBuilder from "@/pages/WorldBuilder";
import Founders from "@/pages/Founders";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/founders" element={<Founders />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/app" element={<Protected><Dashboard /></Protected>} />
      <Route path="/play/:id" element={<Protected><Play /></Protected>} />
      <Route path="/worlds/new" element={<Protected><WorldBuilder /></Protected>} />
      <Route path="/worlds/:id" element={<Protected><WorldBuilder /></Protected>} />
      <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
      <Route path="/payment/cancel" element={<Protected><PaymentCancel /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="font-mono text-xs uppercase tracking-widest text-stone-500">Consulting the archive...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: {
              background: "#12141C",
              border: "1px solid rgba(212,175,55,0.3)",
              color: "#F3EBDD",
              fontFamily: "Spectral, serif",
            },
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}
